/* sdx-pdp-gallery.js — PDP gallery thumbnail switcher.
   Responsibilities:
     1. Bind click + keyboard on thumbnails
     2. Swap main image src, CRITICALLY stripping srcset/sizes
        (without this, browsers keep serving the old srcset candidate
        regardless of src change — see commit 59c6380 for MR.DIY fix)
     3. Manage active state + aria-current for a11y
     4. Move focus ring (not visual focus) to announce change
*/
(function () {
  'use strict';

  function initGallery(root) {
    var mainImg = root.querySelector('[data-sdx-pdp-main]');
    var thumbs = root.querySelectorAll('[data-sdx-pdp-thumb]');
    // Yalnız ilk görselde görünecek katmanlar (ör. ürün hediyesi rozeti)
    var firstOnly = root.querySelectorAll('[data-sdx-pdp-first-only]');
    if (!mainImg || thumbs.length === 0) return;

    function activate(thumb) {
      var fullSrc = thumb.dataset.full;
      if (!fullSrc) return;

      // CRITICAL: strip srcset/sizes so src takes effect.
      // Without this the browser re-resolves srcset against the viewport
      // and keeps painting the previous image.
      mainImg.removeAttribute('srcset');
      mainImg.removeAttribute('sizes');
      mainImg.src = fullSrc;

      // Update alt if thumb carries one (keeps screen readers aligned with visible image)
      var altText = thumb.dataset.alt;
      if (altText) mainImg.alt = altText;

      // Active state
      for (var i = 0; i < thumbs.length; i++) {
        var t = thumbs[i];
        var isActive = t === thumb;
        t.classList.toggle('is-active', isActive);
        t.setAttribute('aria-current', isActive ? 'true' : 'false');
      }

      for (var j = 0; j < firstOnly.length; j++) {
        firstOnly[j].hidden = thumb !== thumbs[0];
      }
    }

    for (var i = 0; i < thumbs.length; i++) {
      (function (thumb) {
        thumb.addEventListener('click', function () {
          activate(thumb);
        });
        thumb.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            activate(thumb);
          }
        });
      })(thumbs[i]);
    }
  }

  function initAll() {
    var galleries = document.querySelectorAll('[data-sdx-pdp-gallery]');
    for (var i = 0; i < galleries.length; i++) initGallery(galleries[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Shopify theme editor — re-init when section is re-rendered
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target && e.target.querySelector
      ? e.target.querySelector('[data-sdx-pdp-gallery]')
      : null;
    if (root) initGallery(root);
  });
})();
